import { apiUrl } from "../../common/api/config";

const headers = () => {
  const token = localStorage.getItem("accessToken");
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: "Bearer " + token,
  };
};

export const getDisplayTemplates = async () => {
  const response = await fetch(`${apiUrl}/display-templates/`, {
    method: "GET",
    headers: headers(),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Failed to fetch templates");
  return data;
};

export const getActiveTemplate = async () => {
  const response = await fetch(`${apiUrl}/display-templates/active/`, {
    method: "GET",
    headers: headers(),
  });
  const data = await response.json();
  if (!response.ok)
    throw new Error(data.error || "Failed to fetch active template");
  return data;
};

export const createDisplayTemplate = async (templateData) => {
  const response = await fetch(`${apiUrl}/display-templates/`, {
    method: "POST",
    headers: headers(),
    body: JSON.stringify(templateData),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Failed to create template");
  return data;
};

export const updateDisplayTemplate = async (templateId, templateData) => {
  const response = await fetch(`${apiUrl}/display-templates/${templateId}/`, {
    method: "PUT",
    headers: headers(),
    body: JSON.stringify(templateData),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Failed to update template");
  return data;
};

export const deleteDisplayTemplate = async (templateId) => {
  const response = await fetch(`${apiUrl}/display-templates/${templateId}/`, {
    method: "DELETE",
    headers: headers(),
  });
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || "Failed to delete template");
  }
};

export const activateDisplayTemplate = async (templateId) => {
  const response = await fetch(
    `${apiUrl}/display-templates/${templateId}/activate/`,
    {
      method: "POST",
      headers: headers(),
    },
  );
  const data = await response.json();
  if (!response.ok)
    throw new Error(data.error || "Failed to activate template");
  return data;
};

export const pushDisplayTemplate = async () => {
  const response = await fetch(`${apiUrl}/display-templates/push/`, {
    method: "POST",
    headers: headers(),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Failed to push template");
  return data;
};

export const saveMyPreferences = async (preferencesData) => {
  const response = await fetch(`${apiUrl}/display-templates/my-preferences/`, {
    method: "POST",
    headers: headers(),
    body: JSON.stringify(preferencesData),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Failed to save preferences");
  return data;
};

export const resetMyPreferences = async () => {
  const response = await fetch(`${apiUrl}/display-templates/my-preferences/`, {
    method: "DELETE",
    headers: headers(),
  });
  const data = await response.json();
  if (!response.ok)
    throw new Error(data.error || "Failed to reset preferences");
  return data;
};

export const shareDisplayTemplate = async (templateId, targetProjectId) => {
  const response = await fetch(
    `${apiUrl}/display-templates/${templateId}/share/`,
    {
      method: "POST",
      headers: headers(),
      body: JSON.stringify({ target_project_id: targetProjectId }),
    },
  );
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Failed to share template");
  return data;
};
